import { Skeleton as ChakraSkeleton, SkeletonProps } from '@chakra-ui/react/skeleton'
import { Circle } from '@chakra-ui/react'
import { Stack } from '@chakra-ui/react/stack'
import * as React from 'react'

type SkeletonCircleProps = SkeletonProps & {
  size?: string
}

export const SkeletonCircle = React.forwardRef(function SkeletonCircle(
  props: SkeletonCircleProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const { size, ...rest } = props
  return (
    <Circle size={size} asChild ref={ref}>
      <ChakraSkeleton {...rest} />
    </Circle>
  )
})

type SkeletonTextProps = SkeletonProps & {
  noOfLines?: number
  gap?: number
}

export const SkeletonText = React.forwardRef(function SkeletonText(
  props: SkeletonTextProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const { noOfLines = 3, gap, ...rest } = props
  return (
    <Stack gap={gap} width="full" ref={ref}>
      {Array.from({ length: noOfLines }).map((_, index) => (
        <ChakraSkeleton height="4" key={index} {...props} _last={{ maxW: '80%' }} {...rest} />
      ))}
    </Stack>
  )
})

export const Skeleton = ChakraSkeleton
